export default __webpack_public_path__ + "static/media/victoria.fa948be3.jpg";